// extracted by mini-css-extract-plugin
export default {"component":"l8Sc23","active":"WSxPm9","clickable":"pR8Toc","content":"iXbs6h"};